// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  --ion-item-background: #ffffff;
  --padding-start: 10px;
  --padding-end: 10px;
  --inner-padding-end: 0px;
  background: #f9f9fb;
  --background: #f9f9fb;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.15s;
  --background-focused: unset !important;
  --border-style: solid;
  --border-width: 1px;
  --border-radius: 8px;
  --border-color: transparent ;
}

ion-item.item-interactive-disabled {
  --background: transparent;
  background: transparent;
  border: 1px solid #a7a7a7;
  box-shadow: unset;
}

ion-item.item-interactive-disabled > ion-input {
  --background: transparent;
  background: transparent;
}

ion-item.item-interactive-disabled > ion-input > input {
  opacity: 1 !important;
}

ion-input {
  transition: all 0.15s;
  background: #f9f9fb;
  text-indent: 8px;
  color: #576D7C;
  font-size: 20px;
  font-weight: 600;
}

input {
  opacity: 0.89 !important;
  position: relative;
}

ion-label {
  margin: 0;
  margin-bottom: 4px !important;
  text-align: center;
  align-self: center !important;
}

.input-header {
  color: #65B2E5;
  font-size: 20px;
  font-weight: 600;
}

ion-grid,
ion-col {
  padding-left: 0;
  padding-right: 0;
}

.show-hide-pwd {
  width: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/input/input.component.scss"],"names":[],"mappings":"AAAA;EACC,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,2CAAA;EACA,qBAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;AACD;;AAEA;EACC,yBAAA;EACG,uBAAA;EACA,yBAAA;EACA,iBAAA;AACJ;;AAEA;EACC,yBAAA;EACG,uBAAA;AACJ;;AAEA;EACC,qBAAA;AACD;;AAEA;EACC,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACD;;AAEA;EACC,wBAAA;EACA,kBAAA;AACD;;AAEA;EACC,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;AACD;;AAEA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AACD;;AAEA;;EAEC,eAAA;EACA,gBAAA;AACD;;AAEA;EACC,WAAA;AACD","sourcesContent":["ion-item {\r\n\t--ion-item-background: #ffffff;\r\n\t--padding-start: 10px;\r\n\t--padding-end: 10px;\r\n\t--inner-padding-end: 0px;\r\n\tbackground: #f9f9fb;\r\n\t--background: #f9f9fb;\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 0px 0px 15px #00000033;\r\n\ttransition: all 0.15s;\r\n\t--background-focused: unset !important;\r\n\t--border-style: solid;\r\n\t--border-width: 1px;\r\n\t--border-radius: 8px;\r\n\t--border-color: transparent\r\n}\r\n\r\nion-item.item-interactive-disabled {\r\n\t--background: transparent;\r\n    background: transparent;\r\n    border: 1px solid #a7a7a7;\r\n    box-shadow: unset;\r\n}\r\n\r\nion-item.item-interactive-disabled > ion-input {\r\n\t--background: transparent;\r\n    background: transparent;\r\n}\r\n\r\nion-item.item-interactive-disabled > ion-input > input {\r\n\topacity: 1 !important;\r\n}\r\n\r\nion-input {\r\n\ttransition: all 0.15s;\r\n\tbackground: #f9f9fb;\r\n\ttext-indent: 8px;\r\n\tcolor: #576D7C;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n}\r\n\r\ninput {\r\n\topacity: 0.89 !important;\r\n\tposition: relative;\r\n}\r\n\r\nion-label {\r\n\tmargin: 0;\r\n\tmargin-bottom: 4px !important;\r\n\ttext-align: center;\r\n\talign-self: center !important;\r\n}\r\n\r\n.input-header {\r\n\tcolor: #65B2E5;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n}\r\n\r\nion-grid,\r\nion-col {\r\n\tpadding-left: 0;\r\n\tpadding-right: 0;\r\n}\r\n\r\n.show-hide-pwd {\r\n\twidth: 24px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
